import React from 'react';
import { useStowageStore } from 'src/context/StowageContext';
import { OperationMenuWrapper } from '../OperationListView.styles';
import BerthOperationListContextMenu from './BerthOperationListContextMenu';
import { RotationBerthCall } from 'src/types/ViewModel/Stowage/Rotation/RotationBerthCall';

type Props = {
    berthCall: RotationBerthCall;
};

const BerthOperationListContextMenuWrapperComponent: React.FC<Props> = (props) => {
    const { berthOperationListContextMenuState } = useStowageStore();

    return (
        <OperationMenuWrapper>
            {berthOperationListContextMenuState.visible &&
                berthOperationListContextMenuState.berthCall.berthCallGuid === props.berthCall.berthCallGuid && (
                    <BerthOperationListContextMenu contextMenuState={berthOperationListContextMenuState} />
                )}
        </OperationMenuWrapper>
    );
};

export default BerthOperationListContextMenuWrapperComponent;
